import { Observable } from 'rxjs';
import { QuerySnapshot, Query, DocumentReference, DocumentSnapshot } from '@firebase/firestore-types';

const snapShot$ = (ref: DocumentReference) =>
  new Observable<DocumentSnapshot>(observer => {
    return ref.onSnapshot({
      next: sn => observer.next(sn),
      error: err => observer.error(err),
    });
  });

const querySnapShot$ = (ref: Query) =>
  new Observable<QuerySnapshot>(observer => {
    return ref.onSnapshot({
      next: sn => observer.next(sn),
      error: err => observer.error(err),
    });
  });

export {
  snapShot$,
  querySnapShot$,
};



// WEBPACK FOOTER //
// ./src/util.tsx